import type { TeamStats } from '../protocol/gen/warinspace/v2/server_to_client_pb.js';

export interface TeamStatsView {
  readonly blueKills: number;
  readonly redKills: number;
  readonly blueScrap: number;
  readonly redScrap: number;
}

export function teamStatsViewFrom(stats: TeamStats): TeamStatsView {
  return {
    blueKills: stats.blueKills,
    redKills: stats.redKills,
    blueScrap: Number(stats.blueScrapAccrued),
    redScrap: Number(stats.redScrapAccrued),
  };
}

export function formatScrap(value: number): string {
  const whole = Math.max(0, Math.round(value));
  if (whole < 10_000) return String(whole);
  if (whole < 1_000_000) return `${(whole / 1000).toFixed(whole < 100_000 ? 1 : 0)}k`;
  return `${(whole / 1_000_000).toFixed(1)}M`;
}

/** Bar split, guarded so an all-zero round draws an even split rather than dividing by zero. */
export function scrapShare(blue: number, red: number): number {
  const total = blue + red;
  return total <= 0 ? 0.5 : blue / total;
}
